import type { RootState } from "@/app/store";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

type State = {
  fileNme: string;
  fileType: string;
};

const initialState: State = {
  fileNme: "",
  fileType: "",
};

const iecSlice = createSlice({
  name: "iec",
  initialState,
  reducers: {
    setIecFile: (
      state,
      action: PayloadAction<{ name: string; type: string }>,
    ) => {
      state.fileNme = action.payload.name;
      state.fileType = action.payload.type;
    },
    clearIecFile: (state) => {
      return initialState;
    },
  },
});

export const { setIecFile, clearIecFile } = iecSlice.actions;
export default iecSlice.reducer;

export const getIecFileInfo = (state: RootState) => state.iec;
